export default {
    home: '/',
    configurator: '/konfiguruj.html',
    // tech_tips: '/porady-techniczne.html',
    about_us: '/o-nas.html',
    contact: '/kontakt.html',
    rodo: '/rodo.html',
    tipsEdit: '/edytuj-porady.html'
}